import * as Sentry from '@sentry/vue';
import type { App } from 'vue';
import type { Router } from 'vue-router';
import { SENTRY_IGNORE_ERRORS } from '@ais-web/commons/shared/constant/sentryIgnore';
import { getAccountName, getUserId } from '@ais-web/commons/shared/utils';

/**
 * 初始化 Sentry 错误监控
 * @param app Vue 应用实例
 * @param router Vue Router 实例
 */
export const initSentry = (app: App<Element>, router: Router) => {
  // 仅在生产环境初始化（Vite 内置布尔标记）
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      // 追踪 vue 错误，上报 props，保留控制台错误输出
      ignoreErrors: SENTRY_IGNORE_ERRORS,
      // 是否开启堆栈跟踪
      attachStacktrace: true,
      // 区分环境（与项目名拼接，便于看板过滤）
      environment: `${process.env.NODE_ENV}-ais-self-service`,
      // 错误事件不采样，全部上报
      sampleRate: 1.0,
      tracesSampleRate: 0.1,
      integrations: [
        Sentry.browserTracingIntegration({
          tracePropagationTargets: [
            'ai.cninsights.com.cn/',
            'www.aisens.com.cn/',
            'www.aisensebot.com/',
            /^\//,
          ],
          router,
        }),
      ],
      // 统一过滤一些常见的无效错误
      beforeSend(event) {
        /* 自定义添加数据 */
        event.extra = {
          userId: getUserId(),
          accountName: getAccountName() || 'unknown',
        };
        return event;
      },
    });
  }
};
